import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_CSR_LIST,
  GET_TERRITORIES_LIST,
  GET_AUDITOR_LIST,
  GET_ORGANIZATION_LIST,
  GET_FINANCE_OFFICER_LIST,
  ADD_STAFF,
  UPDATE_STAFF,
  DELETE_STAFF,
  GET_ACCOUNTANT_LIST,
  GET_DISPATCHER_LIST,
  GET_STAFF_LIST,
  UPDATE_STAFF_LIST,
  GET_HISTORY_LIST_DISPATCHER
} from "./actionTypes";

import {
  getCSRListSuccess,
  getCSRListFail,
  getDatabaseadminListSuccess,
  getDatabaseadminListFail,
  getOrganizationListSuccess,
  getOrganizationListFail,
  getFinanceOfficerListSuccess,
  getFinanceOfficerListFail,
  getAuditorListSuccess,
  getAuditorListFail,
  getRegistrationAdminListSuccess,
  getRegistrationAdminListFail,
  addStaffSuccess,
  addStaffFail,
  getTerritoriesListSuccess,
  getTerritoriesListFail,
  updateStaffSuccess,
  updateStaffFail,
  deleteStaffSuccess,
  deleteStaffFail,
  getaccountantListSuccess,
  getaccountantListFail,
  getdispatcherListFail,
  getdispatcherListSuccess,
  getActivityLogDispatcherSuccess,
  getActivityLogDispatcherFail,
  getStaffListSuccess,
  getStaffListFail,
  updateStaffListSuccess,
  updateStaffListFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getCSRList,
  getOrganizationList,
  getAuditorList,
  getRegistrationAdminList,
  addStaff,
  updateStaff,
  deleteStaff,
  getTerritoriesList,
  getaccountantList,
  getdispatcherList,
  getStaffListApi,
  updateStaffList,
  getHistoryDispatcher
} from "../../helpers/django_api_helper";

function* fetchCSRList(object) {
  try {
    const response = yield call(getCSRList, object.payload);
    yield put(getCSRListSuccess(response));
  } catch (error) {
    yield put(getCSRListFail(error));
  }
}

function* fetchTerritoriesList(object) {
  try {
    const response = yield call(getTerritoriesList, object.payload);
    yield put(getTerritoriesListSuccess(response));
  } catch (error) {
    yield put(getTerritoriesListFail(error));
  }
}
function* fetchAuditorList(action) {
  try {
    const response = yield call(getAuditorList, action.payload);
    yield put(getDatabaseadminListSuccess(response));
  } catch (error) {
    yield put(getDatabaseadminListFail(error));
  }
}

function* fetchOrganizationList() {
  try {
    const response = yield call(getOrganizationList);
    yield put(getOrganizationListSuccess(response));
  } catch (error) {
    yield put(getOrganizationListFail(error));
  }
}

function* fetchFinanceOfficerList(action) {
  try {
    const response = yield call(getRegistrationAdminList, action.payload);
    yield put(getRegistrationAdminListSuccess(response));
  } catch (error) {
    yield put(getRegistrationAdminListFail(error));
  }
}
function* onAddStaff({ payload: { staff, userID } }) {
  try {
    const response = yield call(addStaff, userID, staff);
    if (response.status == 400) {
      yield put(addStaffFail(response.message));
    } else {
      yield put(addStaffSuccess(response));
    }
  } catch (error) {
    yield put(addStaffFail(error));
  }
}

function* onUpdateStaff({ payload: staff }) {
  try {
    const response = yield call(updateStaff, staff);
    yield put(updateStaffSuccess(response));
  } catch (error) {
    yield put(updateStaffFail(error));
  }
}

function* onDeleteStaff({ payload: staff }) {
  try {
    const response = yield call(deleteStaff, staff);
    yield put(deleteStaffSuccess(response));
  } catch (error) {
    yield put(deleteStaffFail(error));
  }
}
function* fetchAccountantList(object) {
  try {
    const response = yield call(getaccountantList, object.payload);
    yield put(getaccountantListSuccess(response));
  } catch (error) {
    yield put(getaccountantListFail(error));
  }
}
function* fetchDispatcherList(object) {
  try {
    const response = yield call(getdispatcherList, object.payload);
    yield put(getdispatcherListSuccess(response));
  } catch (error) {
    yield put(getdispatcherListFail(error));
  }
}


function* fetchActivityLogDispatcher(action) {
  try {
    const { id } = action.payload;
    console.log("[Saga] Fetching Dispatcher Activity Log for User ID:", id);

    const response = yield call(getHistoryDispatcher, id);

    console.log("[Saga] API Response received:", response);

    yield put(getActivityLogDispatcherSuccess(response));
  } catch (error) {
    console.error("[Saga] Error fetching CSR Activity Log:", error);
    yield put(getActivityLogDispatcherFail(error));
  }
}
function* onUpdateStaffList({ payload: staff }) {
  try {
    const response = yield call(updateStaffList, staff);
    yield put(updateStaffListSuccess(response.data));
  } catch (error) {
    yield put(updateStaffListFail(error));
  }
}

function* fetchStaffList(action) {
  try {
    const { accountId, organizationName } = action.payload;

    const response = yield call(getStaffListApi, accountId, organizationName);

    yield put(getStaffListSuccess(response.data.data));
  } catch (error) {
    yield put(getStaffListFail(error));
  }
}
function* staffSaga() {
  yield takeEvery(GET_CSR_LIST, fetchCSRList);
  yield takeEvery(GET_AUDITOR_LIST, fetchAuditorList);
  yield takeEvery(GET_ORGANIZATION_LIST, fetchOrganizationList);
  yield takeEvery(GET_FINANCE_OFFICER_LIST, fetchFinanceOfficerList);
  yield takeEvery(ADD_STAFF, onAddStaff);
  yield takeEvery(UPDATE_STAFF, onUpdateStaff);
  yield takeEvery(DELETE_STAFF, onDeleteStaff);
  yield takeEvery(GET_TERRITORIES_LIST, fetchTerritoriesList);
  yield takeEvery(GET_ACCOUNTANT_LIST, fetchAccountantList);
  yield takeEvery(GET_DISPATCHER_LIST, fetchDispatcherList);
    yield takeEvery(GET_HISTORY_LIST_DISPATCHER, fetchActivityLogDispatcher);
  yield takeEvery(GET_STAFF_LIST, fetchStaffList);
  yield takeEvery(UPDATE_STAFF_LIST, onUpdateStaffList);
}

export default staffSaga;
